<template>
  <div>
    <b-card class="mb-3">
      <!-- <TitleTable titleTable="Reports — Weight Loss & Inventory" iconTable="fas fa-chart-bar" /> -->
      <TitleTable titleTable="Reports" iconTable="fas fa-chart-bar" />
      <b-nav pills class="wl-filters flex-wrap">
        <b-nav-item
          v-for="tab in visibleTabs"
          :key="tab.id"
          :active="activeTab === tab.id"
          @click="activeTab = tab.id">
          {{ tab.label }}
        </b-nav-item>
      </b-nav>
    </b-card>

    <WlReportsOverview v-if="activeTab === 'overview'" />

    <ReportStock v-else-if="activeTab === 'r1'" />
    <ReportMovements v-else-if="activeTab === 'r2'" />
    <ReportPatients v-else-if="activeTab === 'r3'" />
    <ReportVisits v-else-if="activeTab === 'r4'" />
    <ReportLowStock v-else-if="activeTab === 'r6'" />
    <ReportPrices v-else-if="activeTab === 'r7'" />
    <ReportEnrollmentsByOma v-else-if="activeTab === 'r8'" />

    <b-card v-else-if="activeTab === 'r5'">
      <h5 class="font-weight-bold mb-2">R5 — GLP-1 consumption</h5>
      <p class="text-muted small">
        Visits with injection vs outbound inventory movements.
      </p>
      <b-button variant="primary" class="mb-3" @click="loadConsumption">
        Generate view
      </b-button>
      <b-table
        v-if="consumptionRows.length"
        :items="consumptionRows"
        :fields="consumptionFields"
        bordered
        responsive
        small />
    </b-card>
  </div>
</template>

<script>
import { BCard, BNav, BNavItem, BButton, BTable } from 'bootstrap-vue'
import TitleTable from '@/components/TitleTable.vue'
import WlReportsOverview from './WlReportsOverview.vue'
import ReportStock from './ReportStock.vue'
import ReportMovements from './ReportMovements.vue'
import ReportPatients from './ReportPatients.vue'
import ReportVisits from './ReportVisits.vue'
import ReportLowStock from './ReportLowStock.vue'
import ReportPrices from './ReportPrices.vue'
import ReportEnrollmentsByOma from './ReportEnrollmentsByOma.vue'
import invMovementsApi from '@/core/services/api/weightloss-inventory/movements'
import wlAdminMixin from '../mixins/wlAdminMixin'
import wlLaneMixin from '../mixins/wlLaneMixin'
import { isWeightlossReportAdmin } from '../utils/wlRoles'

export default {
  name: 'WlReportsHub',
  mixins: [wlAdminMixin, wlLaneMixin],
  components: {
    BCard,
    BNav,
    BNavItem,
    BButton,
    BTable,
    TitleTable,
    WlReportsOverview,
    ReportStock,
    ReportMovements,
    ReportPatients,
    ReportVisits,
    ReportLowStock,
    ReportPrices,
    ReportEnrollmentsByOma,
  },
  data() {
    return {
      activeTab: 'overview',
      tabs: [
        { id: 'overview', label: 'Dashboard' },
        { id: 'r1', label: 'R1 Stock' },
        { id: 'r2', label: 'R2 Movements' },
        { id: 'r3', label: 'R3 Patients' },
        { id: 'r4', label: 'R4 Visits' },
        { id: 'r5', label: 'R5 Consumption' },
        { id: 'r6', label: 'R6 Below minimum' },
        { id: 'r7', label: 'R7 Prices' },
        { id: 'r8', label: 'R8 Enrollments by OMA', adminOnly: true },
      ],
      consumptionRows: [],
      consumptionFields: [
        { key: 'visit_id', label: 'Visit' },
        { key: 'patient_id', label: 'Patient' },
        { key: 'injection_given', label: 'Injection' },
        { key: 'visit_date', label: 'Date' },
        { key: 'movements_out', label: 'Out movements (sample)' },
      ],
    }
  },
  computed: {
    visibleTabs() {
      const canSeeAdminReports = isWeightlossReportAdmin()
      return this.tabs.filter(t => !t.adminOnly || canSeeAdminReports)
    },
  },
  methods: {
    async loadConsumption() {
      try {
        const params = this.facilityParams()
        const [visits, movements] = await Promise.all([
          this.wlVisitsApi.listPaginated(50, params, 1),
          invMovementsApi.listPaginated(50, { ...params, type: 'out' }, 1),
        ])
        this.consumptionRows = visits.items
          .filter(v => v.injection_given)
          .map(v => ({
            visit_id: v.id,
            patient_id: v.weightloss_patient_id,
            injection_given: v.injection_given ? 'Yes' : 'No',
            visit_date: v.visit_date ? String(v.visit_date).slice(0, 10) : '—',
            movements_out: movements.items.length,
          }))
      } catch (e) {
        console.error(e)
      }
    },
  },
}
</script>
